import React, { useEffect, useRef } from "react";
import { MathJaxContext } from "better-react-mathjax";
import Loading from "./loading";
import ViewStatusEvaluation from "./viewStatusEvaluation";
import CustomExamWrapperView from "./customExamWrapperView";
import mathJaxConfig from "./mathJaxConfig";
import TypesOfQuestionsEnum from "./typesOfQuestionsEnum";
import Tippy from "@tippyjs/react";

const CustomExamExtendedWrapperView = ({ blockPaste, saveLogs, updateDidDismiss, didDismiss, useLogging, updateLogs, pollMode, saveAnswersCritical, scrollAmount, updateScrollAmount, flip, updateQuestions, lastStartTime, requestLifeCycleFour, flags, updateFlags, contentsNeedToBeSaved, updateContentsNeedToBeSaved, status, allowedAttemptsProgramming, attempt, error, testsConfigDict, questionsToSave, requestLifeCycleTwo, isDarkTheme, updateIsDarkTheme, useSyntaxHighlighting, updateContents, requestLifeCycle, questions, updateQuestionsToSave, contents }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {            
            ref.current.scrollTo({ top: scrollAmount, behavior: "instant" });
        }

    }, [])

    const codingExists = () => {
        for (let i = 0; i < questions?.length; i++) {
            if (questions[i]?.questionType === TypesOfQuestionsEnum.PROGRAMMING || questions[i]?.questionType === TypesOfQuestionsEnum.LAMBDA) {
                return true;
            }
        }

        return false;
    }
    
    return (
        <>
            {
                requestLifeCycle

                ?

                    <> 
                        <div className="total">
                            <Loading />
                        </div>
                    </>

                :

                <>
                    {
                        questions && questions.length > 0

                        ?

                        <>
                            <div ref={ref} className="custom-programming-exam-wrapper" style={{ position: "relative" }} onScroll={(e) => {
                                updateScrollAmount(e.target.scrollTop);                            
                            }}>
                                {
                                    useLogging && !didDismiss && codingExists() && (
                                        <div className="message-logging">
                                            <div style={{ minWidth: "fit-content" }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                                                </svg>
                                            </div>
                                            Your instructors have enabled comprehensive code logging. Please note that your coding progress and actions over time may be viewed by your instructors.
                                            <Tippy content="Dismiss" placement="top">
                                                <div style={{ minWidth: "fit-content", cursor: "pointer" }} onClick={() => {
                                                    localStorage.setItem("didDismissLogging", "true");
                                                    updateDidDismiss(true);
                                                }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708"/>
                                                    </svg>
                                                </div>
                                            </Tippy>
                                        </div>
                                    )
                                }
                                <MathJaxContext config={mathJaxConfig}>
                                    <CustomExamWrapperView blockPaste={blockPaste} saveLogs={saveLogs} updateLogs={updateLogs} pollMode={pollMode} saveAnswersCritical={saveAnswersCritical} flip={flip} updateQuestions={updateQuestions} lastStartTime={lastStartTime} requestLifeCycleFour={requestLifeCycleFour} flags={flags} updateFlags={updateFlags} contentsNeedToBeSaved={contentsNeedToBeSaved} updateContentsNeedToBeSaved={updateContentsNeedToBeSaved} status={status} allowedAttemptsProgramming={allowedAttemptsProgramming} attempt={attempt} error={error} testsConfigDict={testsConfigDict} questionsToSave={questionsToSave} requestLifeCycleTwo={requestLifeCycleTwo} requestLifeCycle={requestLifeCycle} isDarkTheme={isDarkTheme} updateIsDarkTheme={updateIsDarkTheme} useSyntaxHighlighting={useSyntaxHighlighting} updateContents={updateContents} updateQuestionsToSave={updateQuestionsToSave} contents={contents} questions={questions} grading={false}/>
                                </MathJaxContext>
                            </div>
                        </>

                        :

                        <>
                            <div className="total">
                                <ViewStatusEvaluation text={pollMode ? "No question is currently active for you" : "No questions found for this evaluation."}/>
                            </div>
                        </>

                    }
                </>

            }
        </>
    );
}
export default CustomExamExtendedWrapperView;